import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"close\"><path fill-rule=\"evenodd\" d=\"M10.071 8.264L17.3 1.036l.904-.904 1.807 1.807-.903.904-7.229 7.228 7.229 7.228.903.904-1.807 1.807-.904-.903-7.228-7.229-7.228 7.229-.904.903-1.807-1.807.904-.904 7.228-7.228-7.228-7.228-.904-.904L1.939.132l.904.904 7.228 7.228z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol